import { isArray } from './is'
import { html } from './environment'

const { helpers } = window.validators

export const DEFAULT_VUE_DATA = function (formEl = {}) {
    return {
        action: formEl.action || '',
        method: 'POST',
        hasErrors: false,
        isLoading: false,
        isSubmitted: false,
        isResubmitable: true,
        formData: {},
        messages: []
    }
}

export const DEFAULT_VUE_FORM = {
    delimiters: [ '${', '}' ],
    validations: {
        formData: {},
    },
    computed: {
        /**
         * @return Array
         */
        hasMessages: function () {
            return this.messages.length > 0
        },
        /**
         * Set the correct classes according to the submit status
         *
         * @return Object
         */
        feedbackClasses: function () {
            return {
                'is-error': this.hasErrors,
                'is-loading': this.isLoading,
                'is-success': this.isSubmitted,
            }
        },
    },
    methods: {
        /**
         * Validate the field as the user interact with it.
         *
         * @param
         */
        inputClasses: function (validation) {
            return {
                'is-error': validation.$error,
                'is-dirty': validation.$dirty,
            }
        },

        /**
         * Handle submit manually
         *
         * @param
         */
        submit: function () {
            if (
                // Don't submit if loading
                !this.isLoading &&
                // Check if form can be resubmitted
                (this.isResubmitable ||
                    // Check if form is not allowed to be resubmitted BUT has not been submitted yet
                    (!this.isResubmitable && !this.isSubmitted)
                )
            ) {
                this.hasErrors = false
                this.$v.$touch()

                if (this.$v.$invalid) {
                    this.hasErrors = true

                    //Scroll to 1st error
                    requestAnimationFrame(() => {
                        const $inputError = this.$el.querySelectorAll('.is-error')[0]

                        if($inputError && this.moduleInstance) {
                            this.moduleInstance.call('scrollTo', [$inputError, { duration: 600, offset: -200 }], 'Scroll')
                            $inputError.focus()
                        }
                    })

                    //temp
                    this.messages = [{ message: 'Il semble y avoir une ou plusieurs erreurs.' }]
                } else {
                    this.sendData()
                    this.$v.$reset()
                }
            }
        },
        /**
         * Execute a POST fetch request.
         *
         * @return void
         */
        sendData: function () {
            this.isLoading = true
            this.messages = []
            let isError = false
            let div = document.createElement("div");
            div.classList.add("js-extra-form-data");
    
            let additions = {
                "Page actuelle": location.href,
                "Page précédente": document.referrer,
                _subject: this.$el.dataset.subject || "Formulaire de contact",
                _title_field:
                    this.$el.dataset.title ||
                    this.$el.querySelector("input").getAttribute("name"),
                _category: this.$el.dataset.category || "Contact",
                _nobot: "1",
            };
    
            for (let name in additions) {
                let input = document.createElement("input");
                input.setAttribute("type", "hidden");
                input.setAttribute("name", name);
                input.setAttribute("value", additions[name]);
                div.appendChild(input);
            }
    
            let callback = this.$el.dataset.callback;
            if (callback && window[callback]) {
                try {
                    window[callback](this);
                } catch (error) {
                    // skip
                }
            }
    
            this.$el
                .querySelectorAll(".js-extra-form-data")
                .forEach((e) => e.parentNode.removeChild(e));
    
            this.$el.appendChild(div);
            var formData = new FormData(this.$el);
            fetch(this.action, {
                method: this.method,
                body: formData,
            })
            .then(response => {
                if (response.status !== 200 && response.status !== 202) {
                    isError = true
                }
                return response.json()
            })
            .then(response => {
                if (isError) {
                    this.hasErrors = true
                    this.messages = response
                    this.onSendDataFailure(response)
                } else {
                    this.onSendDataSuccess(response)
                    this.isSubmitted = true
                }
            })
            .catch(() => {
                // Shrug
            })
            .finally(() => {
                this.isLoading = false

                //Scroll to success
                requestAnimationFrame(() => {
                    const $success = this.$el.querySelectorAll('.c-form_success')[0]

                    if($success && this.moduleInstance) {
                        this.moduleInstance.call('scrollTo', [$success, { duration: 600, offset: -200 }], 'Scroll')
                    }
                })

                this.onSendDataFinally()
            })
            if(formData.get("_newsletter")){
                fetch('/wp-json/formsubmit/newsletter', {
                    method: this.method,
                    body: formData,
                })
                .then(response => {
                    if (response.status !== 200 && response.status !== 202) {
                        isError = true
                    }
                    return response.json()
                })
            }
        },
        /**
         * Send Data Hooks
         */
        onSendDataSuccess: function (response) {
            this.$el.style.display = "none";
            this.$el.reset();

            if (this.$el.dataset.redirect) {
                let name = this.$el.dataset.name
                let data = this.formData[name]
                
                if(data) window.location.href = this.$el.dataset.redirect+"?n="+data; else window.location.href = this.$el.dataset.redirect;
            } else {
                this.$el.classList.remove("is-submitting");
                this.$el.classList.add("is-submitted");
                this.$el.nextElementSibling.style.display = "block";
            }

            this.$el
            .querySelectorAll(".js-extra-form-data")
            .forEach((e) => e.parentNode.removeChild(e));
        },
        onSendDataFailure: function (response) {},
        onSendDataFinally: function () {},
    }
}

export const isChecked = function (value) {
    if (value == true) return true
    return false
}

export const isPostalCodeValid = function (postalCode) {
    if (typeof postalCode === 'undefined' || postalCode === '') {
        return true
    }
    return /^(?!.*[DFIOQUdfioqu])[A-VXYa-vxy][0-9][A-Za-z] ?\-?[0-9][A-Za-z][0-9]$/.test(this.formData.postalCode)
}
